import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { Col, Container, Row } from "react-bootstrap";
import { getStorageData, setStorageData } from "utils/helper";
import {
  pageType,
  DefaultPage,
  TablePageSize,
  DOMAIN_CLINKS,
} from "constants/app";
import { agencySearch } from "apiServices/app";
import HeaderComponent from "components/Layout/HeaderComponent";
import LeftSideFilterComponent from "components/SearchOrgList/LeftSideFilterComponent";
import OrgDetailsComponent from "components/SearchOrgList/OrgDetailsComponent";
import TopHeaderSearchComponents from "components/TopHeaderSearchComponents";
import FooterComponent from "components/Layout/FooterComponent";
import classNames from "classnames";
import { useStyles } from "./styles";
import {
  RegionsOption,
  PrisonsOption,
  ProbationRegionsOption,
  AreaCoveredOption,
  TypeOfOrganisationOption,
  CustodyOrCommunityOption,
  RaciallyMinoritisedOption,
  SpecialistOrganisationOption,
} from "pages/SearchClinksOrgList/constants";
import axios from "axios";
import ButtonComponent from "components/FormsComponents/ButtonComponent";
import { FaFilter } from "react-icons/fa";

const SearchOrgList = (props) => {
  const classes = useStyles(props);
  const { formData, setFormData } = props;
  const domain = getStorageData("domain");
  const domain_status = DOMAIN_CLINKS === domain ? true : false;
  const [agencyData, setAgencyData] = useState([]);
  const [currentPage, setCurrentPage] = useState(DefaultPage);
  const [limit, setLimit] = useState(TablePageSize);
  const [totalPages, setTotalPages] = useState(DefaultPage);
  const [totalRecord, setTotalRecord] = useState();
  const [loader, setLoader] = useState(false);
  const [listStatus, setListStatus] = useState(true);
  const [searchStatus, setSearchStatus] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const targeOption = getStorageData("target_option");

  const [filterAllData, setFilterAllData] = useState({
    regions: RegionsOption,
    prisons: PrisonsOption,
    probation_regions: ProbationRegionsOption,
    area_covered: AreaCoveredOption,
    type_of_organisation: TypeOfOrganisationOption,
    custody_or_community: CustodyOrCommunityOption,
    racially_minoritised: RaciallyMinoritisedOption,
    specialist_organisation: SpecialistOrganisationOption,
    target_group:
      targeOption && Object.keys(targeOption).length > 0 ? targeOption : [],
  });
  const [filterData, setFilterData] = useState({
    regions: RegionsOption,
    prisons: PrisonsOption,
    probation_regions: ProbationRegionsOption,
    area_covered: AreaCoveredOption,
    type_of_organisation: TypeOfOrganisationOption,
    custody_or_community: CustodyOrCommunityOption,
    racially_minoritised: RaciallyMinoritisedOption,
    specialist_organisation: SpecialistOrganisationOption,
    target_group:
      targeOption && Object.keys(targeOption).length > 0 ? targeOption : [],
  });

  const onSearchClick = () => {
    if (formData?.pathway?.length || formData?.name || formData?.county) {
      setSearchStatus(false);
      if (currentPage > 1) {
        setCurrentPage(1);
      }
      getAgencySearchData();
    } else {
      setSearchStatus(true);
      return false;
    }
  };
  const getAgencySearchData = () => {
    let sourceToken = axios.CancelToken.source();
    if (
      formData?.pathway?.length ||
      formData?.name ||
      formData?.county.length
    ) {
      setSearchStatus(false);
      setStorageData("user_data", formData);
      setLoader(true);
      agencySearch(
        {
          ...formData,
          page: currentPage,
          limit: limit,
          domain_status: domain_status,
        },
        sourceToken,
      )
        .then(({ data: { data, total_record, total_page }, success }) => {
          if (success === "true") {
            setAgencyData(data);
            setTotalPages(total_page);
            setTotalRecord(total_record);
          }
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
        })
        .finally(() => {});
    } else {
      setSearchStatus(true);
      setAgencyData([]);
      setTotalPages(1);
      setTotalRecord(0);
    }
    return () => sourceToken.cancel();
  };
  useEffect(() => {
    return getAgencySearchData();
  }, [formData, currentPage, limit]);

  const isMobileFilter =
    formData?.regions?.length ||
    formData?.prisons?.length ||
    formData?.probation_regions?.length ||
    formData?.area_covered?.length ||
    formData?.type_of_organisation?.length ||
    formData?.custody_or_community?.length ||
    // formData?.racially_minoritised?.length ||
    formData?.specialist_organisation?.length ||
    formData?.target_group?.length
      ? true
      : false;

  return (
    <>
      <div
        className={classNames(
          classes.orglist__page,
          "orglist__pageCommon orglist__mtc",
        )}
      >
        <HeaderComponent
          className="bg-white w-100"
          isPage={pageType.list}
          {...props}
        />
        <TopHeaderSearchComponents
          formData={formData}
          setFormData={setFormData}
          onSearchClick={onSearchClick}
          className="d-flex flex-wrap justify-content-center odp__search"
          isPage={"list"}
          searchStatus={searchStatus}
          setSearchStatus={setSearchStatus}
        />
        <section className="orgl__section">
          <Container fluid="fluid">
            <Row className="orgl__list">
              <Col className="orgl__left" lg={3}>
                <LeftSideFilterComponent
                  className="sticky-md-top"
                  filterData={filterData}
                  setFilterData={setFilterData}
                  formData={formData}
                  setFormData={setFormData}
                  agencyData={agencyData}
                  filterAllData={filterAllData}
                  setFilterAllData={setFilterAllData}
                  isMobileView={isMobileView}
                  setIsMobileView={setIsMobileView}
                />
              </Col>
              <Col className="orgl__right" lg={9}>
                <OrgDetailsComponent
                  formData={formData}
                  setFormData={setFormData}
                  agencyData={agencyData}
                  totalRecord={totalRecord}
                  totalPages={totalPages}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  loader={loader}
                  domain_status={domain_status}
                  listStatus={listStatus}
                  setListStatus={setListStatus}
                  limit={limit}
                  setLimit={setLimit}
                />
              </Col>
            </Row>
          </Container>
        </section>
        <div className="mob__filter">
          <div className="mob__inner d-flex align-items-center justify-content-center">
            <ButtonComponent
              variant="dark"
              title="Filter"
              className={`${
                isMobileFilter ? "mon__filtered" : ""
              } position-relative`}
              onClick={() => {
                var root = document.getElementsByTagName("html")[0];
                root.setAttribute("class", "filter_overlap");
                setIsMobileView(true);
              }}
            >
              Filter
              <FaFilter className="ms-2" />
            </ButtonComponent>
          </div>
        </div>
        <FooterComponent />
      </div>
    </>
  );
};
SearchOrgList.propTypes = {
  history: propTypes.object,
};
export default SearchOrgList;
